import { Button } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import { addPlane, framePlane, removePlane, selectPlane } from "../../state/planes/planes.actions.ts";
import { planesState } from "../../state/planes/planes.state.ts";
import { setTool } from "../../state/tool/tool.actions.ts";
import { PlaneFields } from "./PlaneFields.tsx";

const HELP =
  "A build plane is a flat surface you add where the model has none — a slab the file omits, a roof that " +
  "was never modelled, the floor of an upper storey. Standards stand on it like on a roof. Planes are saved " +
  "with the design but are never exported or counted.";

/** The build planes: add, pick one, edit it, remove it. */
export function PlanesPanel(): JSX.Element {
  const { planes, selectedId } = planesState.use();
  const selected = planes.find((plane) => plane.id === selectedId) ?? null;

  const handleAdd = (): void => {
    addPlane();
    setTool("plane");
  };

  const handleSelect = (id: string): void => {
    selectPlane(id);
    setTool("plane");
  };

  return (
    <div className="flex flex-col gap-3 overflow-y-auto p-3">
      <div className="flex gap-2">
        <Button onClick={handleAdd} tooltip="A 6 × 4 m plane at the view's orbit point, ready to drag">
          Add plane
        </Button>
        <Button onClick={() => selected && framePlane(selected.id)} disabled={!selected}>
          Go to plane
        </Button>
      </div>

      {planes.length > 0 && (
        <div className="flex flex-col gap-1">
          {planes.map((plane) => (
            <Button
              key={plane.id}
              active={plane.id === selectedId}
              onClick={() => handleSelect(plane.id)}
              className="justify-between"
            >
              <span className="truncate">{plane.name}</span>
              <span className="font-mono text-slate-400">
                {plane.w} × {plane.d} · h {plane.y}
              </span>
            </Button>
          ))}
        </div>
      )}

      {selected && (
        <>
          <PlaneFields plane={selected} />
          <Button onClick={() => removePlane(selected.id)}>Delete plane</Button>
        </>
      )}

      <p className="text-xs leading-relaxed text-slate-400">{HELP}</p>
    </div>
  );
}
